module.exports = __webpack_public_path__ + "static/img/14areaA_5.17e27c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/14areaA_5.png
// module id = 1018
// module chunks = 1